<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper" class="sidebar-wrapper">
        <div class="overlay mobile_overlap"></div>
        <ul class="left-sidebar-wrapper list-unstyled vertical-scrollbar custom-scroll" id="menu">
            <template v-for="(menuData, index) in $store.getters.menuArr">
                <li v-bind:key="index" :id="menuData.slug" :class="'menuCommon '+menuData.slug">
                    <template v-if="menuData.is_view_allow == 1">
                        <template v-if="menuData.sub_menu == '' || menuData.sub_menu == null || menuData.sub_menu_view_count != 1">
                            <template v-if="menuData.url != null && menuData.url != '' && menuData.is_view_allow == 1">
                                <template v-if="menuData.menu_title.length >= 18">
                                    <a :href="menuData.url" target="_blank" data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title">
                                        <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                        <div class="sidebar-name">{{stringTrim(menuData.menu_title,18)}}</div>
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="menuData.url" target="_blank">
                                        <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                        <div class="sidebar-name">{{menuData.menu_title}}</div>
                                    </a>
                                </template>
                            </template>
                            <template v-else-if="menuData.features.length == 1 && (menuData.features[0].name == 'Iframe URL' || menuData.features[0].id == 4) && menuData.iframe_url_arr.length > 0">
                                <template v-if="menuData.iframe_url_arr.length == 1">
                                    <template v-for="(iframeURL, menuIframeIndex) in menuData.iframe_url_arr">
                                        <template v-if="iframeURL != null && iframeURL != ''">
                                            <template v-if="menuData.menu_title.length >= 18">
                                                <a :key="menuIframeIndex" :href="iframeURL" target="_blank" data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title">
                                                    <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                                    <div class="sidebar-name">{{stringTrim(menuData.menu_title,18)}}</div>
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a :key="menuIframeIndex" :href="iframeURL" target="_blank" data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title">
                                                    <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                                    <div class="sidebar-name">{{menuData.menu_title}}</div>
                                                </a>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="menuData.menu_title.length >= 18">
                                        <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                            <div class="sidebar-name">{{stringTrim(menuData.menu_title,18)}}</div>
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                            <div class="sidebar-name">{{menuData.menu_title}}</div>
                                        </router-link>
                                    </template>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 18">
                                    <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                        <div class="sidebar-name">{{stringTrim(menuData.menu_title,18)}}</div>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                        <div class="sidebar-name">{{menuData.menu_title}}</div>
                                    </router-link>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="menuData.url != null && menuData.url != ''">
                                <template v-if="menuData.menu_title.length >= 18">
                                    <a data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" :href="menuData.url" target="_blank">
                                        <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                        <div class="sidebar-name"> {{stringTrim(menuData.menu_title,18)}}</div>
                                        <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                    </a>
                                </template>
                                <template v-else>
                                    <a :href="menuData.url" target="_blank">
                                        <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                        <div class="sidebar-name"> {{menuData.menu_title}}</div>
                                        <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                    </a>
                                </template>
                            </template>
                            <template v-else-if="menuData.features.length == 1 && (menuData.features[0].name == 'Iframe URL' || menuData.features[0].id == 4) && menuData.iframe_url_arr.length > 0">
                                <template v-if="menuData.iframe_url_arr.length == 1">
                                    <template v-for="(iframeURL, menuIframeIndex) in menuData.iframe_url_arr">
                                        <template v-if="iframeURL != null && iframeURL != ''">
                                            <template v-if="menuData.menu_title.length >= 18">
                                                <a :key="menuIframeIndex" data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" :href="iframeURL" target="_blank">
                                                    <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                                    <div class="sidebar-name"> {{stringTrim(menuData.menu_title,18)}}</div>
                                                    <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a :key="menuIframeIndex" data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" :href="iframeURL" target="_blank">
                                                    <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                                    <div class="sidebar-name"> {{menuData.menu_title}}</div>
                                                    <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                                </a>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="menuData.menu_title.length >= 18">
                                        <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                            <div class="sidebar-name"> {{stringTrim(menuData.menu_title,18)}}</div>
                                            <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                            <div class="sidebar-name">{{menuData.menu_title}}</div>
                                            <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                        </router-link>
                                    </template>
                                </template>
                            </template>
                            <template v-else>
                                <template v-if="menuData.menu_title.length >= 18">
                                    <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="menuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                        <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                        <div class="sidebar-name">{{stringTrim(menuData.menu_title,18)}}</div> 
                                        <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                    </router-link>
                                </template>
                                <template v-else>
                                    <template v-if="( loginUserRoleId === 1 || loginUserRoleId === 2 || loginUsername == '14034' || loginUsername == '81038') && menuData.menu_title == 'Manager\'s Section'">
                                        <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                            <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                            <div class="sidebar-name">{{menuData.menu_title}}</div> 
                                            <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <template v-if="menuData.menu_title != 'Manager\'s Section'">
                                            <router-link v-bind:to="{name: 'CommonPage', params:{type:menuData.slug}}">
                                                <span class="menu-icon-wrapper"><i :class="(menuData.icon_code == 1 ? '' : 'sidebar-menu-img ') + menuData.icon_url"></i></span>
                                                <div class="sidebar-name"> {{menuData.menu_title}}</div>
                                                <i class="fa fa-angle-down menu-arrow pull-right" aria-hidden="true"></i>
                                            </router-link>
                                        </template>
                                    </template>
                                </template>
                            </template>
                            <ul class="nav nav-list tree ps-5">
                                <template v-for="(subMenuData, index1) in menuData.sub_menu">
                                    <template v-if="subMenuData.is_view_allow == 1">
                                        <template v-if="subMenuData.url != null && subMenuData.url != '' && subMenuData.is_view_allow == 1">
                                            <li :key="index1" :class="'subMenuLi'+subMenuData.slug">
                                                <template v-if="subMenuData.menu_title.length >= 30">
                                                    <template v-if="subMenuData.url==training_schedular_url">
                                                        <a :title="subMenuData.menu_title" data-bs-toggle="tooltip" data-bs-placement="top" :href="training_schedular_token_url" target="_blank">
                                                            {{stringTrim(subMenuData.menu_title,30)}}
                                                        </a>
                                                    </template>
                                                    <template v-else-if="subMenuData.url==service_desk_url">
                                                        <a data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" :href="service_desk_token_url" target="_blank">
                                                            {{stringTrim(subMenuData.menu_title,30)}}
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        <a data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" :href="subMenuData.url" target="_blank">
                                                            {{stringTrim(subMenuData.menu_title,30)}}
                                                        </a>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="subMenuData.url==training_schedular_url">
                                                        <a data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" :href="training_schedular_token_url" target="_blank">
                                                            {{subMenuData.menu_title}}
                                                        </a>
                                                    </template>
                                                    <template v-else-if="subMenuData.url==service_desk_url">
                                                        <a data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" :href="service_desk_token_url" target="_blank">
                                                            {{subMenuData.menu_title}}
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        <a data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" :href="subMenuData.url" target="_blank">
                                                            {{subMenuData.menu_title}}
                                                        </a>
                                                    </template>
                                                </template>
                                            </li>
                                        </template>
                                        <template v-else-if="subMenuData.features.length == 1 && (subMenuData.features[0].name == 'Iframe URL' || subMenuData.features[0].id == 4) && subMenuData.iframe_url_arr.length > 0">
                                            <template v-if="subMenuData.iframe_url_arr.length == 1">
                                                <template v-for="(submenuIframeURL, submenuIframeIndex) in subMenuData.iframe_url_arr">
                                                    <template v-if="submenuIframeURL != null && submenuIframeURL != ''">
                                                        <li :class="'subMenuLi  '+subMenuData.slug">
                                                            <template v-if="subMenuData.menu_title.length >= 30">
                                                                <a data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" :href="submenuIframeURL" target="_blank">
                                                                    {{stringTrim(subMenuData.menu_title,30)}}
                                                                </a>
                                                            </template>
                                                            <template v-else>
                                                                <a data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" :href="submenuIframeURL" target="_blank">
                                                                    {{subMenuData.menu_title}}
                                                                </a>
                                                            </template>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                                    <template v-if="subMenuData.menu_title.length >= 30">
                                                        <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                            {{stringTrim(subMenuData.menu_title,30)}}
                                                        </router-link>
                                                    </template>
                                                    <template v-else>
                                                        <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                            {{subMenuData.menu_title}}
                                                        </router-link>
                                                    </template>
                                                </li>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <li :key="index1" :class="'subMenuLi '+subMenuData.slug">
                                                <template v-if="subMenuData.menu_title.length >= 30">
                                                    <router-link :title="subMenuData.menu_title"
                                                    data-bs-toggle="tooltip" data-bs-placement="top"  v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                        {{stringTrim(subMenuData.menu_title,30)}}
                                                    </router-link>
                                                </template>
                                                <template v-else-if = "subMenuData.slug == 'forms-truck-specs-pricing'">
                                                    <router-link data-bs-toggle="tooltip" data-bs-placement="top" :title="subMenuData.menu_title" v-bind:to="{name: 'TruckSpecsandPricing'}">
                                                        {{subMenuData.menu_title}}
                                                    </router-link>
                                                </template>
                                                <template v-else>
                                                    <router-link :title="subMenuData.menu_title" 
                                                    data-bs-toggle="tooltip" data-bs-placement="top" v-bind:to="{name: 'CommonPage', params:{type:subMenuData.slug}}">
                                                        {{subMenuData.menu_title}}
                                                    </router-link>
                                                </template>
                                            </li>
                                        </template> 
                                    </template>
                                </template>
                            </ul>
                        </template>
                    </template>
                </li>
            </template>
        </ul>
    </div>
<!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';
    import {HTTP} from '../../http-common.js';
    import EventBus from '.././event-bus';
    var self;

    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: 'Sidebar',
        mixins: [commonMixins],
        data() {
            return {
                menuArr: [],
                loginUserRoleId: 1,
                training_schedular_url:'',
                training_schedular_token_url:'',
                service_desk_url:'',
                service_desk_token_url:'',
                loginUsername: 9999999
            }
        },
        beforeMount: function () {
        },
        mounted: function () {
            self = this;
            // let tkn = localStorage.getItem("tkn");
            // let training_schedular = process.env.VUE_APP_TRAINING_SCHEDULAR_URL;
            // self.training_schedular_url = training_schedular;
            // self.training_schedular_token_url = training_schedular + "?token=" + tkn;
            // let service_desk= process.env.VUE_APP_SERVICE_HELPDESK_URL;
            // self.service_desk_url = service_desk;
            // self.service_desk_token_url = service_desk + "?token=" + tkn;
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".admin-page-content").toggleClass("toggled-2");
            });
            $("#menu-toggle-2").click(function (e) {
                e.preventDefault();
                $(".admin-page-content").toggleClass("toggled");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });
            $('.menu-arrow').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUsername = userJson['username'];

                self.$store.dispatch('loadMenu');
            }
        },
        methods: {
        }
    };
    EventBus.$on('user-role', function (roleId) {
        if (typeof (self) != 'undefined') {
            self.loginUserRoleId = roleId;
        }
    });
    EventBus.$on('reload-menu', function (menuArr) {
        if (typeof (self) != 'undefined') {
            self.$nextTick(() => {
                self.firstLoadMenu();
            });
        }
    });
</script>